(function () {
  /*! loadJS: load a JS file asynchronously. [c]2014 @scottjehl, Filament Group, Inc. Licensed MIT */
  (function (w) {
    var loadJS = function (src, cb, ordered) {
      "use strict";
      var tmp;
      var ref = w.document.getElementsByTagName("script")[0];
      var script = w.document.createElement("script");

      if (typeof cb === "boolean") {
        tmp = ordered;
        ordered = cb;
        cb = tmp;
      }

      script.src = src;
      script.async = !ordered;
      ref.parentNode.insertBefore(script, ref);

      if (cb && typeof cb === "function") {
        script.onload = cb;
      }

      return script;
    };

    if (typeof module !== "undefined") {
      module.exports = loadJS;
    } else {
      w.loadJS = loadJS;
    }
  })(typeof global !== "undefined" ? global : this);

  document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains("template-product")) return;

    loadJS("https://a.klaviyo.com/media/js/onsite/onsite.js", function () {
      var klaviyo = window.klaviyo || [];

      klaviyo.init({
        account: "VANrwd",
        platform: "shopify"
      });

      klaviyo.enable("backinstock", {
        trigger: {
          product_page_text: "Notify Me When Available",
          product_page_class: "btn btn--medium btn--full btn--primary",
          product_page_text_align: "center",
          product_page_margin: "0px",
          replace_anchor: false
        },
        modal: {
          headline: "{product_name}",
          body_content: "Register to receive a notification when this item comes back into stock. <br><br> Be sure to check your spam or promotions folders for emails from Skin Devotee, otherwise you may miss the notification when this product comes back into stock.",
          email_field_label: "Email",
          button_label: "Notify me when available",
          subscription_success_label: "You're in! We'll let you know when it's back.",
          footer_content: "",
          additional_styles:
            ".modal-title { text-transform: uppercase; letter-spacing: 0.075em; } " +
            ".btn.btn--medium.btn--full.btn--primary { text-transform: uppercase; letter-spacing: 0.125em; }",
          drop_background_color: "#000",
          background_color: "#fff",
          text_color: "#292929",
          button_text_color: "#fff",
          button_background_color: "#454647",
          close_button_color: "#ccc",
          error_background_color: "#fcd6d7",
          error_text_color: "#C72E2F",
          success_background_color: "#d3efcd",
          success_text_color: "#1B9500"
        }
      });
    });
  });
})();